function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import icArrow from 'assets/svg/ic_arrow_fill.svg';
import { useTestId } from '@wolffun/testable-id';

const PaginationControl = ({
  className,
  page,
  totalPages,
  onPageChange
}) => {
  const [currentPage, setCurrentPage] = React.useState(page || 1);
  const {
    generateTestIdProps
  } = useTestId();
  React.useEffect(() => {
    if (page > 0) {
      setCurrentPage(page);
    }
  }, [page]);

  const renderPageNumber = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.center
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.wrapInput
    }, /*#__PURE__*/React.createElement("input", _extends({}, generateTestIdProps('input-page-number'), {
      type: "number",
      onKeyDown: e => {
        if (e.key === 'Enter') {
          onPageChange(currentPage || 1);
        }
      },
      onChange: e => {
        const number = parseInt(e.target.value, 10) || 0; // input only accept positive number

        if (number >= totalPages) {
          setCurrentPage(totalPages);
          return;
        }

        setCurrentPage(Math.abs(number));
      },
      value: currentPage.toString(),
      className: styles.current
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles.total
    }, /*#__PURE__*/React.createElement("span", generateTestIdProps('page-total'), "of ", totalPages)));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.paginationWrapper)
  }, /*#__PURE__*/React.createElement("button", {
    disabled: page === 1,
    onClick: () => onPageChange(page - 1),
    type: "button",
    className: styles.pageItem
  }, /*#__PURE__*/React.createElement("img", {
    src: icArrow,
    className: styles.icon
  })), renderPageNumber(), /*#__PURE__*/React.createElement("button", {
    disabled: page === totalPages,
    onClick: () => onPageChange(page + 1),
    type: "button",
    className: styles.pageItem
  }, /*#__PURE__*/React.createElement("img", {
    src: icArrow,
    className: classNames(styles.icNext, styles.icon)
  })));
};

export default PaginationControl;